import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';
import { EducationLevel } from './education-level.interface';

export class EducationLevelService {
   async getEducationLevels() {
      return await http.get<Array<EducationLevel>>(`/education-levels`, cacheFirstConfig).then((response) => response.data);
   }
}
